import { addWorkflowToGlobalRegistry } from "@orchestration/definitions/registry/global-registry";
import type { WorkflowDefinition } from "./workflow-definition.types";

export function registerWorkflows(workflows: readonly WorkflowDefinition[]): void {
  for (const workflow of workflows) addWorkflowToGlobalRegistry(workflow);
}
